<template>
  <div class="feature-card-community-feature-card" v-bind:class="rootClassName">
    <h2 class="feature-card-community-text">{{ title }}</h2>
    <span class="feature-card-community-text1">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'FeatureCardCommunity',
  props: {
    rootClassName: String,
    description: {
      type: String,
      default:
        'Opifex strives to provide a safe and welcoming work environment for all employees.',
    },
    title: {
      type: String,
      default: 'Community',
    },
  },
}
</script>

<style scoped>
.feature-card-community-feature-card {
  width: 100%;
  display: flex;
  padding: 32px;
  align-items: center;
  flex-direction: column;
}
.feature-card-community-text {
  font-style: normal;
  margin-top: var(--dl-space-space-unit);
  text-align: center;
  font-weight: 500;
  margin-bottom: var(--dl-space-space-unit);
}
.feature-card-community-text1 {
  color: var(--dl-color-gray-700);
  text-align: center;
}

@media(max-width: 1200px) {
  .feature-card-community-text1 {
    color: var(--dl-color-gray-black);
  }
}
</style>
